import React, {PureComponent} from 'react';
import ReactTooltip from "react-tooltip";
import $ from "jquery";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import View from "ol/View";
import {fromLonLat} from "ol/proj";
import Overlay from "ol/Overlay";
import Feature from "ol/Feature";
import LineString from "ol/geom/LineString";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Map from "ol/Map";
import marshallIcon from "../../img/marshall.png";
import Alert from "react-s-alert";
import {Modal} from 'react-responsive-modal';
import {formatDate} from "../functions/utils";
import MessageComponent from "../independentComponents/messageComponent";
import SessionClosedModal from "../independentComponents/sessionClosedWarningModalComponent";
import BroadcastMessageComponent from "../independentComponents/broadcastMessageComponent";
import PortraitModal from "../independentComponents/portraitModalComponent";
import ReplyModal from "../independentComponents/replyModalComponent";
import FlagModal from "../independentComponents/flagModalComponent";
import MarshallWarningComponent from "../independentComponents/marshallWarningComponent";
import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";
import parallel from "async/parallel";

import {
    closeSocket,
    confirmIdentity,
    confirmSession,
    connectSocket,
    subscribeDashToServer,
    subscribeSessionStatus,
    subscribeToPitInfo
} from "../functions/api";
import logo from "../../img/logo_small.png";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;
const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const messagePort = process.env.REACT_APP_MESSAGE_PORT;

// Create a pattern, offscreen
const patternCanvas = document.createElement('canvas');
const patternContext = patternCanvas.getContext('2d');
// Give the pattern a width and height of 50
patternCanvas.width = 50;
patternCanvas.height = 50;
// Empty session status
let emptyStatus = [];

class FlagMonitor extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            toggleFlagPanel: false,
            sessionDetails: {
                circuit: "---",
                circuit_id: -1,
                event_id: -1,
                length: 0,
                length_delimiter: "time",
                map_center_lat: 0,
                map_center_lng: 0,
                map_center_zoom_level: 0,
                map_rotation: 0,
                order_factor: "bestlap",
                session: "---",
                start_timestamp: 0,
                scheduled_start_timestamp: 0,
                timezone: "---",
                track_length: 0,
            },
            carList: [
                {
                    id: 0,
                    livery_number: 0,
                    short_name: "---",
                    title: "---",
                    flagStatus: [],
                    instructionFlag: null,
                    pit_live: {
                        text: "---",
                        textColor: "#FFFFFF",
                        spd: 1000,
                        sts: -10,
                        rsi: 1,
                    }
                }
            ],
            collectiveFlags: [
                {id: -1, desc: "---", src: "none_transparent.png", first_color: "", second_color: ""},
            ],
            singularFlags: [
                {id: -1, desc: "---", src: "none_transparent.png", first_color: "", second_color: ""},
            ],
            fullCourseFlags: [
                {id: -1, desc: "---", src: "none_transparent.png", first_color: "", second_color: ""},
            ],
            flagList: [],
            marshallPosts: [],
            sessionStatus: [],
            receivalNumber: 0,
            equalStatusDNF: 0,
            instructionFlagsActive: 0,
            retiredVehiclesCount: 0,
            readyToSubscribeReply: false,
            sessionStatusOBJ: [],
            pendingMsgOrg: {},
            pendingMsgTeam: {},
        };

        this.getSessionDetails = this.getSessionDetails.bind(this);
        this.getCarList = this.getCarList.bind(this);
        this.getFlagList = this.getFlagList.bind(this);
        this.getMarshallPostList = this.getMarshallPostList.bind(this);

        this.sendFlag = this.sendFlag.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.clearSessionStatus = this.clearSessionStatus.bind(this);
        this.clearDriverInstruction = this.clearDriverInstruction.bind(this);
        this.statusIDtoObj = this.statusIDtoObj.bind(this);
        this.statusParser = this.statusParser.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        parallel([
            (p_callback) => {
                this.getSessionDetails((status) => {
                    p_callback(null, status);
                });
            },
            (p_callback) => {
                this.getCarList((status) => {
                    p_callback(null, status);
                });
            },
            (p_callback) => {
                this.getFlagList((status) => {
                    p_callback(null, status);
                });
            },
            (p_callback) => {
                this.getMarshallPostList((status) => {
                    // Build empty status
                    for (let i = 0; i < this.state.marshallPosts.length; i++) {
                        emptyStatus.push(0);
                    }
                    p_callback(null, status);
                });
            },
        ]);

        if ($(window).width() > 1200) {
            setTimeout(() => {
                this.toggleSidebar();
            }, 1000);
        }

        confirmIdentity(this.props.cookies.get("authToken"), this.props.match.params.userID, this.props.match.params.eventID, (confirmed) => {
            if (confirmed) {
                $('.loading').fadeOut();
                // Connect Socket
                connectSocket(this.props.cookies.get("authToken"), null, this.props.match.params.sessionID, this.props.match.params.eventID, "FLAGPANEL", (msg) => {
                    console.log("[FLAG MONITOR]" + msg);
                    subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
                        console.log("[FLAG MONITOR] DEDICATED STREAM SUBSCRIBED");
                        this.setState({
                            readyToSubscribeReply: true,
                        });
                    });

                    subscribeToPitInfo(this.props.match.params.eventID, false, (err, pitInfo) => {
                        let temp = this.state.carList.slice();
                        let retiredVehiclesCount = 0;
                        for (let c = 0; c < this.state.carList.length; c++) {
                            temp[c].pit_live = {
                                text: "---",
                                textColor: "#FFFFFF",
                                spd: 1000,
                                sts: -10,
                                rsi: -1,
                            };
                            for (let i = 0; i < pitInfo.length; i++) {
                                if (temp[c].id === pitInfo[i].cid) {
                                    temp[c].pit_live = pitInfo[i];
                                    switch (pitInfo[i].sts) {
                                        case (0): {
                                            temp[c].pit_live.text = this.props.t("onTrack").toUpperCase();
                                            temp[c].pit_live.textColor = "#FFFFFF";
                                            break;
                                        }
                                        case (1): {
                                            temp[c].pit_live.text = this.props.t("pitEntry");
                                            temp[c].pit_live.textColor = "#007bff";
                                            break;
                                        }
                                        case (2): {
                                            temp[c].pit_live.text = this.props.t("box").toUpperCase();
                                            temp[c].pit_live.textColor = "#ffc700";
                                            break;
                                        }
                                        case (3): {
                                            temp[c].pit_live.text = this.props.t("pitExit").toUpperCase();
                                            temp[c].pit_live.textColor = "#007bff";
                                            break;
                                        }
                                        case (4): {
                                            temp[c].pit_live.text = this.props.t("outLap").toUpperCase();
                                            temp[c].pit_live.textColor = "#00ff1b";
                                            break;
                                        }
                                        default: {
                                            temp[c].pit_live.text = "---";
                                            temp[c].pit_live.textColor = "#ffffff";
                                            break;
                                        }
                                    }
                                    break;
                                }
                            }
                        }

                        for (let i = 0; i < temp.length; i++) {
                            if ([-1, 2, 3].includes(parseInt(temp[i].pit_live.rsi))) {
                                retiredVehiclesCount++;
                            }
                        }

                        this.setState({
                            carList: temp,
                            retiredVehiclesCount: retiredVehiclesCount,
                        });
                    });

                    subscribeSessionStatus(this.props.match.params.eventID, false, (err, pack) => {
                        let temp = this.state.carList.slice();
                        let equalStatusCount = this.state.carList.length;
                        let equalStatusDNF = 0;
                        let equalIndexes = [];
                        let instructionFlagsActive = 0;

                        for (let i = 0; i < temp.length; i++) {

                            temp[i].instructionFlag = this.statusIDtoObj([pack.crs["" + temp[i].id].ins])[0];
                            temp[i].flagStatus = this.statusParser(pack.crs["" + temp[i].id].sts);

                            if (temp[i].instructionFlag !== 0 && temp[i].instructionFlag !== null && temp[i].instructionFlag !== undefined) {
                                instructionFlagsActive++;
                            }

                            for (let post = 0; post < this.state.marshallPosts.length; post++) {
                                if (temp[i].flagStatus[post] !== this.state.sessionStatus[post]) {
                                    equalStatusCount--;
                                    break;
                                }

                                if (post === (this.state.marshallPosts.length - 1)) {
                                    equalIndexes.push(i);
                                }
                            }
                        }

                        for (let c = 0; c < equalIndexes.length; c++) {
                            if (temp[equalIndexes[c]].pit_live && [-1, 2, 3].includes(parseInt(temp[equalIndexes[c]].pit_live.rsi))) {
                                equalStatusDNF++;
                            }
                        }

                        // UPDATE only when change is detected
                        let newStatus = this.statusParser(pack.sts);
                        this.setState({
                            sessionStatus: this.statusParser(pack.sts),
                            sessionStatusOBJ: this.statusIDtoObj(newStatus),
                            carList: temp,
                            receivalNumber: equalStatusCount,
                            equalStatusDNF: equalStatusDNF,
                            instructionFlagsActive: instructionFlagsActive,
                            pendingMsgOrg: pack.com,
                            pendingMsgTeam: pack.cgm,
                        });
                    });
                });
            } else {
                this.setState({
                    confirmed: false,
                });
            }
        });
    }

    componentWillUnmount() {
        subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
            console.log("[FLAG PANEL] DEDICATED STREAM UNSUBSCRIBED");
        });
        subscribeSessionStatus(this.props.match.params.eventID, true, null);
        subscribeToPitInfo(this.props.match.params.eventID, true, null);
        closeSocket();
    }

    /* GET INFO */
    getSessionDetails(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionDetails',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                helper.setState({
                    sessionDetails: data,
                }, () => {
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getCarList(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getCarList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                userID: helper.props.match.params.userID,
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                for (let i = 0; i < data.length; i++) {
                    data[i].flagStatus = [];
                    data[i].instructionFlag = null;
                }
                helper.setState({
                    carList: data,
                }, () => {
                    callback("ok");
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                helper.setState({
                    carList: [{
                        id: 0, livery_number: 0, short_name: "---", title: "---"
                    }]
                }, () => {
                    callback("nok");
                });
            }
        });
    }

    getFlagList(callback) {
        const helper = this;
        $.ajax({
            type: 'GET',
            url: serverIP + ":" + backendPort + '/dashboard/getFlagList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            success: function (data) {
                helper.setState({
                    collectiveFlags: data.collective,
                    singularFlags: data.singular,
                    fullCourseFlags: data.fullCourse,
                    flagList: data.collective.concat(data.singular).concat(data.fullCourse),
                }, () => {
                    callback("ok");
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                helper.setState({
                    collectiveFlags: [
                        {id: -1, desc: "---", src: "none_transparent.png"}
                    ],
                    singularFlags: [
                        {id: -1, desc: "---", src: "none_transparent.png"}
                    ]
                }, () => {
                    callback("nok");
                });
            }
        });
    }

    getMarshallPostList(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getMarshallPostList',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                if (data && data.length > 0) {
                    helper.setState({
                        marshallPosts: data
                    }, () => {
                        callback("ok");
                    });
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    statusIDtoObj(arr) {
        if (this.state.flagList.length > 0) {
            let temp = [];
            for (let i = 0; i < arr.length; i++) {
                temp.push(null);
                for (let j = 0; j < this.state.flagList.length; j++) {
                    if (this.state.flagList[j].id === arr[i]) {
                        temp[i] = this.state.flagList[j];
                        break;
                    }
                }
            }
            return temp;
        } else {
            return [];
        }
    }

    statusParser(sts) {
        let newStatus = [];
        let found = false;

        for (let p = 0; p < this.state.marshallPosts.length; p++) {

            found = false;

            for (let s = 0; s < Object.keys(sts).length; s++) {
                if (this.state.marshallPosts[p].order_no === parseInt(Object.keys(sts)[s])) {
                    newStatus.push(sts[Object.keys(sts)[s]]);
                    found = true;
                    break;
                }
            }

            if (!found) {
                newStatus.push(0);
            }
        }

        return newStatus;
    }

    /* ACTIONS */
    sendFlag(arr, flagID, carID, entry_countdown, exit_countdown, instructionMessage, next_flag, callback) {

        let statusArray = null;

        if (arr) {
            statusArray = arr.slice();
        }

        /*console.log(
            "statusArray: ", statusArray, "\n",
            "flagID: ", flagID, "\n",
            "carID: ", carID, "\n",
            "entry_countdown: ", entry_countdown, "\n",
            "exit_countdown: ", exit_countdown, "\n",
            "instructionMessage: ", instructionMessage, "\n",
            "next_flag: ", next_flag, "\n"
        );*/

        confirmSession(this.props.cookies.get("authToken"), this.props.match.params.eventID, this.props.match.params.sessionID, (isClosed) => {

            const helper = this;

            if (isClosed) {
                this.setState({
                    isSessionClosed: true,
                });

            } else {
                if (carID && carID >= 0) {

                    let url =
                        telemetryIP + ':' + messagePort + '/command-worker-device?' +
                        'command=RT-ORG-CAR-FLAG-MSG' +
                        '&eventId=' + helper.props.match.params.eventID +
                        '&carId=' + carID +
                        '&sessionId=' + helper.props.match.params.sessionID +
                        '&msgFlagTypeId=' + flagID +
                        '&userId=' + helper.props.match.params.userID;

                    $.ajax({
                        type: 'POST',
                        url: url,
                        headers: {
                            'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
                        },
                        contentType: "application/json",
                        dataType: 'json',
                        data: JSON.stringify({
                            "message": instructionMessage,
                        }),
                        success: function () {
                            console.log('[FLAG MONITOR] Successfully sent device message display request.');
                            callback(null, "ok");
                        }, error: function (err) {
                            console.error('[FLAG MONITOR] Error sending flag:', err);
                            callback(err, "nok");
                        }
                    });
                } else {

                    let url =
                        telemetryIP + ':' + messagePort + '/command-worker-device?' +
                        'command=RT-ORG-SESSION-FLAG-MSG' +
                        '&eventId=' + helper.props.match.params.eventID +
                        '&sessionId=' + helper.props.match.params.sessionID +
                        '&userId=' + helper.props.match.params.userID +
                        '&isMarshallPostLayoutLegacy=' + helper.state.sessionDetails.is_legacy_marshall;

                    $.ajax({
                        type: 'POST',
                        url: url,
                        headers: {
                            'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
                        },
                        contentType: "application/json",
                        dataType: 'json',
                        data: JSON.stringify({
                            "sts": statusArray,
                            "entry": entry_countdown === 0 ? null : entry_countdown,
                            "exit": exit_countdown === 0 ? null : exit_countdown,
                            "next": next_flag,
                        }),
                        success: function () {
                            console.log('[FLAG MONITOR] Successfully sent device message display request.');
                            callback(null, "ok");
                        }, error: function (err) {
                            console.error('[FLAG MONITOR] Error sending flag:', err);
                            callback(err, "nok");
                        }
                    });
                }
            }
        });
    }

    /* HANDLERS */
    toggleSidebar() {
        this.setState({
            toggleFlagPanel: !this.state.toggleFlagPanel,
        }, () => {
            if (this.state.toggleFlagPanel) {
                if ($(window).width() > 1200) {
                    // Set the width of the sidebar to 250px and the left margin of the page content to 250px
                    document.getElementById("mySidebar").style.width = "26%";
                    document.getElementById("main").style.marginLeft = "26%";
                } else {
                    // Hide clock if screen too small
                    document.getElementById("myNav").style.width = "100%";
                }
            } else {
                if ($(window).width() > 1200) {
                    // Set the width of the sidebar to 0 and the left margin of the page content to 0
                    document.getElementById("mySidebar").style.width = "0";
                    document.getElementById("main").style.marginLeft = "0";
                } else {
                    document.getElementById("myNav").style.width = "0%";
                }
            }
        });
    }

    clearSessionStatus() {
        this.sendFlag(emptyStatus, null, null, null, null, null, -1, (err, result) => {
            if (err) {
                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("actionError") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            } else {
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("sessionCleared") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }
        });
    }

    clearDriverInstruction(carID) {
        this.sendFlag(null, 0, carID, null, null, null, null, (err, result) => {
            if (err) {
                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("actionError") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            } else {
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("instructionCleared") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }
        });
    }

    /* RENDER */
    render() {
        return (
            <div className={"container-fluid App_steel_background"}>
                {this.state.readyToSubscribeReply ? (
                    <>
                        <ReplyModal
                            carID={undefined}
                            driverName={undefined}
                            driverID={undefined}
                            sessionID={this.props.match.params.sessionID}
                            eventID={this.props.match.params.eventID}
                            pendingMsgOrg={this.state.pendingMsgOrg}
                            pendingMsgTeam={this.state.pendingMsgTeam}
                            privileges={[1]}
                        />
                        <FlagModal
                            sessionID={this.props.match.params.sessionID}
                            eventID={this.props.match.params.eventID}
                            carID={null}
                            convertFlags={this.statusIDtoObj}
                            marshallPosts={this.state.marshallPosts}
                        />
                    </>
                ) : (
                    <div/>
                )}
                <SessionClosedModal
                    isSessionClosed={this.state.isSessionClosed}
                />
                <Alert stack={{limit: 10}} html={true}/>
                <div className="loading">
                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                </div>
                <div id={$(window).width() > 1200 ? "mySidebar" : "myNav"} className={$(window).width() > 1200 ? "sidebar App_steel_background" : "overlay"}>
                    {$(window).width() > 1200 ? "" : (<span className={"closebtn"} style={{zIndex: 100}} onClick={this.toggleSidebar}>&times;</span>)}
                    <div className={$(window).width() > 1200 ? "container-fluid" : "container-fluid overlay-content"} style={{height: "100%",}}>
                        <FlagPanel
                            toggleFlagPanel={this.state.toggleFlagPanel}
                            eventID={this.props.match.params.eventID}
                            sessionID={this.props.match.params.sessionID}
                            userID={this.props.match.params.userID}
                            sessionDetails={this.state.sessionDetails}
                            carList={this.state.carList}
                            collectiveFlags={this.state.collectiveFlags}
                            fullCourseFlags={this.state.fullCourseFlags}
                            sendFlag={this.sendFlag}
                            sessionStatus={this.state.sessionStatusOBJ}
                            marshallPosts={this.state.marshallPosts}
                            t={this.props.t}
                            cookies={this.props.cookies}
                        />
                    </div>
                </div>
                <div id={"main"} className={"row"}>
                    <FlagDashboard
                        isGuest={false}
                        toggleSidebar={this.toggleSidebar}
                        eventID={this.props.match.params.eventID}
                        sessionID={this.props.match.params.sessionID}
                        userID={this.props.match.params.userID}
                        sessionStatus={this.state.sessionStatus}
                        sessionDetails={this.state.sessionDetails}
                        carList={this.state.carList}
                        clearSessionStatus={this.clearSessionStatus}
                        clearDriverInstruction={this.clearDriverInstruction}
                        sendFlag={this.sendFlag}
                        flagList={this.state.flagList}
                        singularFlags={this.state.singularFlags}
                        fullCourseFlags={this.state.fullCourseFlags}
                        receivalNumber={this.state.receivalNumber}
                        retiredVehiclesCount={this.state.retiredVehiclesCount}
                        equalStatusDNF={this.state.equalStatusDNF}
                        instructionFlagsActive={this.state.instructionFlagsActive}
                        pendingMsgOrg={this.state.pendingMsgOrg}
                        pendingMsgTeam={this.state.pendingMsgTeam}
                        marshallPosts={this.state.marshallPosts}
                        t={this.props.t}
                        cookies={this.props.cookies}
                        statusIDtoObj={this.statusIDtoObj}
                    />
                </div>
            </div>
        );
    }
}

class FlagDashboard extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            searchVehicle: "",
            sessionStatusObj: [],
            flagModalOpen: false,
            selectedCarID: -1,
            modalTitle: "---",
            currentInstructionFlagID: -1,
            instructionMessage: "",
        };

        this.handleClearDriverInstruction = this.handleClearDriverInstruction.bind(this);
        this.handleChangeVehicleSearch = this.handleChangeVehicleSearch.bind(this);
        this.handleClickInstructionFlag = this.handleClickInstructionFlag.bind(this);
        this.handleOpenInstructionFlagModal = this.handleOpenInstructionFlagModal.bind(this);
        this.handleCloseInstructionFlagModal = this.handleCloseInstructionFlagModal.bind(this);
        this.handleChangeInstructionMessage = this.handleChangeInstructionMessage.bind(this);
        this.handleSendInstructionFlag = this.handleSendInstructionFlag.bind(this);
    }

    /* LIFE CYCLE */
    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((prevProps.sessionStatus && this.props.sessionStatus)) {
            if (JSON.stringify(prevProps.sessionStatus) !== JSON.stringify(this.props.sessionStatus)) {
                this.setState({
                    sessionStatusObj: this.props.statusIDtoObj(this.props.sessionStatus),
                });
            }
        }
    }

    /* HANDLERS */
    handleChangeVehicleSearch(e) {
        e.preventDefault();
        if (!isNaN(e.target.value)) {
            let number = e.target.value;
            this.setState({
                searchVehicle: number,
            });
        }
    }

    handleClickInstructionFlag(e) {
        let flagID = parseInt(e.target.id);
        this.setState({
            currentInstructionFlagID: flagID,
        });
    }

    handleSendInstructionFlag() {
        this.props.sendFlag(null, this.state.currentInstructionFlagID, this.state.selectedCarID, null, null, this.state.instructionMessage, null, (err, msg) => {
            if (err) {
                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("couldNotSendThisFlag") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 15000,
                    offset: 150
                });
            } else {
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("flagSent") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }
            this.handleCloseInstructionFlagModal();
        });
    }

    handleClearDriverInstruction(e) {
        this.props.clearDriverInstruction(parseInt(e.target.id));
    }

    handleOpenInstructionFlagModal(e) {
        let carID = parseInt(e.target.id);
        let liveryNumber = -1;
        for (let i = 0; i < this.props.carList.length; i++) {
            if (this.props.carList[i].id === carID) {
                liveryNumber = this.props.carList[i].livery_number;
                break;
            }
        }
        this.setState({
            flagModalOpen: true,
            selectedCarID: carID,
            modalTitle: this.props.t("sendInstructionFlagTo") + "#" + liveryNumber,
        });
    }

    handleCloseInstructionFlagModal() {
        this.setState({
            flagModalOpen: false,
            selectedCarID: -1,
            modalTitle: "---",
            currentInstructionFlagID: -1,
            instructionMessage: "",
        });
    }

    handleChangeInstructionMessage(e) {
        this.setState({
            instructionMessage: e.target.value,
        });
    }

    /* RENDER */
    render() {
        return (
            <>
                <PortraitModal/>
                <div className={"container-fluid"}>
                    <div className={"row"}>
                        <div className={"col-xs-12 w3-animate-zoom row-flex"} style={{marginTop: 10}}>
                            <div className={"col-xs-1"} style={{paddingLeft: 0}}>
                                <button className={"openbtn button"} style={{whiteSpace: "nowrap", width: "100%", marginBottom: 5}} onClick={this.props.toggleSidebar}>
                                    <i className={"fas fa-align-justify"}/> <i className={"fas fa-flag"}/>
                                </button>
                                <CarDisplayLogModal
                                    customTitle={this.props.t("sessionState")}
                                    sessionID={this.props.sessionID}
                                    eventID={this.props.eventID}
                                    userID={this.props.userID}
                                    statusIDtoObj={this.statusIDtoObj}
                                    sessionDetails={this.props.sessionDetails}
                                    marshallPosts={this.props.marshallPosts}
                                    t={this.props.t}
                                    cookies={this.props.cookies}
                                />
                                <button data-tip={true} data-for={"clearStatus"} className={"openbtn button"} style={{whiteSpace: "nowrap", width: "100%", marginTop: 5}} onClick={this.props.clearSessionStatus}>
                                    <i className={"fas fa-eraser"}/>
                                </button>
                                <ReactTooltip id={"clearStatus"} type={"light"}>
                                    <span className={"organizerPanel_tooltipStyle"}>{this.props.t("clearAll")}</span>
                                </ReactTooltip>
                            </div>
                            <div className={"col-xs-11 App_sectionContainer w3-animate-zoom row-flex"}>
                                <MarshallWarningComponent
                                    marshallPosts={this.props.marshallPosts}
                                    sendFlag={this.props.sendFlag}
                                    fullCourseFlags={this.props.fullCourseFlags}
                                    sessionStatus={this.state.sessionStatusObj}
                                    isSingleVehicle={false}
                                    enableClick={true}
                                    isFlagPanel={true}
                                    hasTooltip={true}
                                />
                            </div>
                        </div>
                        <div className={"col-xs-12"} style={{marginTop: 20, height: "80%"}}>
                            <div className={" App_sectionContainer w3-animate-zoom"}>
                                <div className={"App_ContainerStyle table-scroll-parent"} style={{whiteSpace: "nowrap", height: "calc(100vh - 150px)"}}>
                                    <div className={"table-scroll-child table-responsive"}>
                                        <table className={"table table-condensed borderTest"} style={{textAlign: "center"}}>
                                            <thead>
                                            <tr>
                                                <th colSpan={2}>
                                                    <div className={"col-sm-12"}>
                                                        <BroadcastMessageComponent
                                                            eventID={this.props.eventID}
                                                            sessionID={this.props.sessionID}
                                                            userID={this.props.userID}
                                                        />
                                                    </div>
                                                </th>
                                                <th>
                                                    <input
                                                        className={"form-control App_black_text"}
                                                        style={{border: "2px solid #ed2126", height: 40}}
                                                        value={this.state.searchVehicle}
                                                        placeholder={"000"}
                                                        type={"text"}
                                                        onChange={this.handleChangeVehicleSearch}/>
                                                </th>
                                                <th colSpan={11}/>
                                            </tr>
                                            <tr>
                                                <th style={{width: "7%"}}/>
                                                <th className={"App_header"} style={{width: "10%"}}>{this.props.t("instFlag")} ({this.props.instructionFlagsActive - this.props.equalStatusDNF}/{this.props.carList.length - this.props.retiredVehiclesCount})</th>
                                                <th className={"App_header"} style={{width: "7%"}}>{this.props.t("vehicle")}</th>
                                                <th className={"App_header"} style={{width: "7%"}}>{this.props.t("spd")}</th>
                                                <th className={"App_header"} style={{width: "69%", textAlign: "left"}}>{this.props.t("marshall_warnings")} ({this.props.receivalNumber - this.props.equalStatusDNF}/{this.props.carList.length - this.props.retiredVehiclesCount})</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.props.carList.filter((car) => {
                                                if (car.pit_live && [0, 1, 4].includes(parseInt(car.pit_live.rsi))) {
                                                    if (!isNaN(parseInt(this.state.searchVehicle))) {
                                                        if (("" + car.livery_number).indexOf(this.state.searchVehicle) !== -1) {
                                                            return true;
                                                        } else {
                                                            return false;
                                                        }
                                                    } else {
                                                        return true;
                                                    }
                                                } else {
                                                    return false;
                                                }
                                            }).map((car) => {
                                                return (
                                                    <tr key={"car_" + car.id} className={"App_white_text"}>
                                                        <td className={"App_bold_text"} style={{color: car.pit_live ? car.pit_live.textColor : "#FFFFFF"}}>
                                                            {car.pit_live ? car.pit_live.text : "---"}
                                                        </td>
                                                        <td>
                                                            {car.instructionFlag ? (
                                                                <img id={car.id}
                                                                     style={{marginTop: 0, width: "70%"}}
                                                                     className={"organizerPanel_flagStyle w3-animate-zoom blink"}
                                                                     src={serverIP + ":" + backendPort + "/images/flags/" + (car.instructionFlag ? car.instructionFlag.src : "none_transparent.png")}
                                                                     alt={"flag"}
                                                                     onClick={this.handleClearDriverInstruction}
                                                                />
                                                            ) : (
                                                                <img
                                                                    id={car.id}
                                                                    style={{marginTop: 0, width: "70%"}}
                                                                    className={"organizerPanel_flagStyle w3-animate-zoom"}
                                                                    src={(serverIP + ":" + backendPort + "/images/flags/none_transparent.png")}
                                                                    alt={"flag"}
                                                                    onClick={this.handleOpenInstructionFlagModal}
                                                                />
                                                            )}
                                                        </td>
                                                        <td>
                                                            <CarDisplayLogModal
                                                                car={car}
                                                                sessionID={this.props.sessionID}
                                                                eventID={this.props.eventID}
                                                                userID={this.props.userID}
                                                                statusIDtoObj={this.statusIDtoObj}
                                                                sessionDetails={this.props.sessionDetails}
                                                                t={this.props.t}
                                                                cookies={this.props.cookies}
                                                                marshallPosts={this.props.marshallPosts}
                                                            />
                                                            <div style={{margin: 0, padding: 0, height: 5}}/>
                                                            <MessageComponent
                                                                disable={false}
                                                                isGuest={this.props.isGuest}
                                                                carID={car.id}
                                                                isOwnTeam={undefined}
                                                                driverName={undefined}
                                                                liveryNumber={car.livery_number}
                                                                eventID={this.props.eventID}
                                                                sessionID={this.props.sessionID}
                                                                userID={this.props.userID}
                                                                privileges={[1]}
                                                                pendingMsgOrg={this.props.pendingMsgOrg}
                                                                pendingMsgTeam={this.props.pendingMsgTeam}
                                                            />
                                                        </td>
                                                        <td>
                                                            <div className={"App_flagContainer"} style={{borderColor: "#FFFFFF", cursor: "initial"}}>
                                                                {car.pit_live && car.pit_live.spd < 500 ? car.pit_live.spd : "---"} km/h
                                                            </div>
                                                        </td>
                                                        <td style={{fontSize: 15, height: "10vh"}}>
                                                            <div className={"col-xs-12 App_sectionContainer w3-animate-zoom row-flex"} style={{height: "100%"}}>
                                                                <MarshallWarningComponent
                                                                    marshallPosts={this.props.marshallPosts}
                                                                    sendFlag={this.props.sendFlag}
                                                                    fullCourseFlags={this.props.fullCourseFlags}
                                                                    sessionStatus={this.props.statusIDtoObj(car.flagStatus)}
                                                                    isSingleVehicle={true}
                                                                    enableClick={false}
                                                                    isFlagPanel={true}
                                                                    hasTooltip={true}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal open={this.state.flagModalOpen}
                       onClose={this.handleCloseInstructionFlagModal}
                       center={false}
                       classNames={{modal: "small-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            <span className={"toolTipStyle"}>{this.state.modalTitle}</span>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        <div className={"container-fluid"}>
                            <div className={"row"}>
                                {this.props.singularFlags.map((flag) => {
                                    return (
                                        <div key={"singular_" + flag.id} className={"col-xs-3"}>
                                            <img
                                                id={flag.id}
                                                className={"organizerPanel_flagStyle"}
                                                style={this.state.currentInstructionFlagID === flag.id ? ({
                                                    boxShadow: "0px 1px 6px 5px rgba(235, 31, 36, 1)"
                                                }) : ({})}
                                                src={(serverIP + ":" + backendPort + "/images/flags/" + flag.src)}
                                                alt={"flag"}
                                                data-tip={true}
                                                data-for={flag["desc_" + this.props.cookies.get("lang")]}
                                                onClick={this.handleClickInstructionFlag}
                                            />
                                            <ReactTooltip id={flag["desc_" + this.props.cookies.get("lang")]} type={"light"}>
                                                <span className={"organizerPanel_tooltipStyle"}>{flag["desc_" + this.props.cookies.get("lang")]}</span>
                                            </ReactTooltip>
                                        </div>
                                    );
                                })}
                            </div>
                            <br/>
                            <div className={"row"}>
                                <div className={"col-xs-12"}>
                                    <input
                                        id={"instructionMessage"}
                                        className={"form-control App_black_text"}
                                        type={"text"}
                                        placeholder={this.props.t("addMessageToPilot")}
                                        onChange={this.handleChangeInstructionMessage}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"modal-footer"}>
                        <div className={"col-sm-12 text-right"}>
                            <button
                                className={"btn App_white_text"}
                                style={{background: "#ff0003", color: "#FFFFFF", marginBottom: 20, fontWeight: "bold"}}
                                disabled={this.state.currentInstructionFlagID < 0}
                                onClick={this.handleSendInstructionFlag}
                            >{this.props.t("sendFlag")}
                            </button>
                            <button
                                className={"btn App_white_text"}
                                style={{background: "#ff0003", color: "#FFFFFF", marginBottom: 20, fontWeight: "bold"}}
                                onClick={this.handleCloseInstructionFlagModal}
                            >{this.props.t("close")}
                            </button>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}

class FlagPanel extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            selectedCarID: null,
            selectedFlagID: -1,
            selectedFlagObj: null,
            isCollective: false,
            isSingular: false,
            isFullCourse: false,
            flagOK: false,
            flagRows: [],
            selectedPosts: [],
            confirmedOrg: true,
            countdown: 0,
            flagModalOpen: false,
            modalTitle: "",
            instructionMessage: "",
        };

        this.drawFlags = this.drawFlags.bind(this);
        this.setupMap = this.setupMap.bind(this);
        this.putMarshallPosts = this.putMarshallPosts.bind(this);
        this.makeFullPolyline = this.makeFullPolyline.bind(this);

        this.handleClickFlag = this.handleClickFlag.bind(this);
        this.handleCloseFlagModal = this.handleCloseFlagModal.bind(this);
        this.handleSendFlag = this.handleSendFlag.bind(this);
        this.handleCountdownChange = this.handleCountdownChange.bind(this);

        this.closeNav = this.closeNav.bind(this);
    }

    /* LIFE CYCLE */
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.fullCourseFlags !== this.props.fullCourseFlags) {
            this.drawFlags();
        }
        if (prevProps.toggleFlagPanel !== this.props.toggleFlagPanel && this.map) {
            setTimeout(() => {
                this.map.updateSize();
            }, 500);
        }
    }

    /* HANDLERS */
    closeNav() {
        this.props.toggleSidebar((toggleCarList) => {
            if (!toggleCarList) {
                document.getElementById("myNav").style.width = "0%";
            }
        });
    }

    handleClickFlag(e) {

        const parts = e.target.id.split("_");
        const flagID = parseInt(parts[0]);
        const isCollective = parseInt(parts[1]);
        const isFullCourse = parseInt(parts[2]);

        // VERIFY IF THERE IS AN ACTIVE FULL-COURSE AT THE MOMENT
        if (this.props.sessionStatus[0]) {
            if (
                (this.props.sessionStatus[0].is_full_course === 1 && this.props.sessionStatus[(this.props.marshallPosts.length - 1)].is_full_course === 1) &&
                (isCollective === 1 && isFullCourse === 0)
            ) {
                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("partialNotAllowedOnFullCourse") + '</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 30000,
                    offset: 150
                });
                return false;
            }
        }
        this.setState({
            selectedFlagID: flagID,
        }, () => {
            if (isFullCourse === 1) {
                // Clicked a full-course flag
                for (let i = 0; i < this.props.fullCourseFlags.length; i++) {
                    if (this.props.fullCourseFlags[i].id === this.state.selectedFlagID) {
                        this.setState({
                            isCollective: true,
                            isSingular: false,
                            isFullCourse: true,
                            selectedCarID: null,
                            selectedPosts: this.props.marshallPosts,
                            selectedFlagObj: this.props.fullCourseFlags[i],
                            modalTitle: this.props.t("fullCourseSelected"),
                        }, () => {
                            this.setState({
                                flagOK: true,
                            });
                        });
                        break;
                    }
                }
            } else {
                // Clicked a collective flag
                for (let i = 0; i < this.props.collectiveFlags.length; i++) {
                    if (this.props.collectiveFlags[i].id === this.state.selectedFlagID) {
                        this.setState({
                            isCollective: true,
                            isSingular: false,
                            isFullCourse: false,
                            selectedCarID: null,
                            selectedPosts: [],
                            selectedFlagObj: this.props.collectiveFlags[i],
                            modalTitle: this.props.t("partialSelected"),
                        }, () => {
                            this.setState({
                                flagOK: false,
                            });
                        });
                        break;
                    }
                }
            }
        });

        this.setState({
            flagModalOpen: true,
        }, () => {
            setTimeout(() => {
                this.setupMap();
            }, 400);
        });
    }

    handleCloseFlagModal() {
        this.setState({
            flagModalOpen: false,
            selectedCarID: null,
        });
    }

    handleSendFlag() {
        let statusArray = [];

        for (let i = 0; i < this.props.marshallPosts.length; i++) {
            let found = false;
            for (let j = 0; j < this.state.selectedPosts.length; j++) {
                if (i === this.state.selectedPosts[j].order_no) {
                    found = true;
                    break;
                }
            }
            if (found) {
                statusArray.push(this.state.selectedFlagID);
            } else {
                if (this.props.sessionStatus[i]) {
                    statusArray.push(this.props.sessionStatus[i].id);
                } else {
                    statusArray.push(0);
                }
            }
        }

        this.props.sendFlag(statusArray, this.state.selectedFlagID, this.state.selectedCarID, this.state.countdown, null, this.state.instructionMessage, null, (error, ok) => {
            if (error) {
                console.error('Error sending device message display request.');
                this.setState({
                    flagOK: false,
                });
                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("couldNotSendThisFlag") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 15000,
                    offset: 150
                });
            } else {
                this.setState({
                    flagOK: false,
                    selectedCarID: null,
                    countdown: 0,
                });

                try {
                    document.getElementById('countdownFlag').value = null;
                } catch (e) {
                    console.log("[ORGANIZER PANEL] Could not reset selector. Probably not rendered. This error is not critical.");
                }

                try {
                    document.getElementById('selectSectorHighLightFrom').selectedIndex = 0;
                    document.getElementById('selectSectorHighLightTo').selectedIndex = 0;
                    document.getElementById('singularFlagCarSelect').selectedIndex = 0;
                    document.getElementById('countdownFlag').value = null;
                } catch (e) {
                    console.log("[ORGANIZER PANEL] Could not reset selector. Probably not rendered. This error is not critical.");
                }

                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("flagSent") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }
            this.setState({
                flagModalOpen: false,
                instructionMessage: "",
            });
        });
    }

    handleCountdownChange(e) {
        if (parseInt(e.target.value) > 0) {
            this.setState({
                countdown: parseInt(e.target.value),
            });
        }
    }

    setupMap() {
        let mapZoomCompensation = 0;
        if (this.state.isSingular) {
            mapZoomCompensation = -5;
        } else if (!this.state.isSingular && !this.state.isFullCourse) {
            mapZoomCompensation = 4;
        }

        this.map = new Map({
            target: "flag_modal_map",
            layers: [
                new TileLayer({
                    source: new XYZ({
                        attributions: 'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer">ArcGIS</a>',
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                    })
                }),
            ],
            view: new View({
                center: fromLonLat([this.props.sessionDetails.map_center_lng, this.props.sessionDetails.map_center_lat]),
                zoomFactor: 1.1,
                zoom: this.props.sessionDetails.map_center_zoom_level + mapZoomCompensation,
                maxZoom: 141,
                rotation: this.props.sessionDetails.map_rotation,
            }),
            loadTilesWhileAnimating: true,
            loadTilesWhileInteracting: true,
        });

        setTimeout(() => {
            this.map.updateSize();
            this.putMarshallPosts();
        }, 600);
    }

    makeFullPolyline() {
        let temp = [];
        for (let post = 0; post < this.props.marshallPosts.length; post++) {
            for (let point = 0; point < this.props.marshallPosts[post].polyline.length; point++) {
                temp.push(fromLonLat([
                    this.props.marshallPosts[post].polyline[point].lng,
                    this.props.marshallPosts[post].polyline[point].lat,
                ]));
            }
        }
        return temp;
    }

    putMarshallPosts() {
        const helper = this;
        // Place them on the map
        for (let i = 0; i < this.props.marshallPosts.length; i++) {

            const innerDiv = $('' +
                '<div class="marshallFlag w3-animate-fading">' +
                '   <span id= "marshall_' + this.props.marshallPosts[i].id + '" class="sectorText">' + this.props.marshallPosts[i].name + ' </span>' +
                '   <img style="height: 100%; width:100%" src="' + marshallIcon + '" alt="sector"/>' +
                '</div>'
            ).get(0);

            let newMarshallPost = new Overlay({
                element: innerDiv,
                position: fromLonLat([this.props.marshallPosts[i].post_lng, this.props.marshallPosts[i].post_lat]),
                offset: [-2, 4],
                positioning: 'bottom-left',
            });

            let style = null;
            if (helper.state.selectedFlagObj.second_color) {
                let color1 = helper.state.selectedFlagObj.first_color;
                let color2 = helper.state.selectedFlagObj.second_color;
                let numberOfStripes = 50;
                for (let x = 0; x < numberOfStripes * 2; x++) {
                    let thickness = 300 / numberOfStripes;
                    patternContext.beginPath();
                    patternContext.strokeStyle = x % 2 ? color1 : color2;
                    patternContext.lineWidth = thickness;
                    patternContext.lineCap = 'round';

                    patternContext.moveTo(x * thickness + thickness / 2 - 300, 0);
                    patternContext.lineTo(x * thickness + thickness / 2, 300);
                    patternContext.stroke();
                }

                // Create our primary canvas and fill it with the pattern
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const pattern = ctx.createPattern(patternCanvas, 'repeat');
                ctx.fillStyle = pattern;
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                style = new Style({
                    stroke: new Stroke({
                        lineCap: "round",
                        lineJoin: "round",
                        width: 9,
                        color: pattern,
                    }),
                });
            } else {
                style = new Style({
                    stroke: new Stroke({
                        lineCap: "round",
                        lineJoin: "round",
                        width: 9,
                        color: helper.state.selectedFlagObj.first_color,
                    }),
                });
            }

            this.map.addOverlay(newMarshallPost);

            if (this.state.isCollective && !this.state.isFullCourse) {
                $('#marshall_' + this.props.marshallPosts[i].id).click((e) => {

                    console.log("[FLAG PANEL] CLICKED ON " + helper.props.marshallPosts[i].name);

                    let featureArr = [];
                    this.map.getLayers().forEach((layer) => {
                        if (layer.get('name') === "marshalls") {
                            this.map.removeLayer(layer);
                            return true;
                        }
                    });

                    // Check if this post is already selected. If it is, un-select it
                    let found = false;
                    let temp = this.state.selectedPosts.slice();
                    for (let j = 0; j < temp.length; j++) {
                        if (temp[j].id === this.props.marshallPosts[i].id) {
                            found = true;
                            temp.splice(j, 1);
                            break;
                        }
                    }
                    if (!found) {
                        temp.push(this.props.marshallPosts[i]);
                    }
                    this.setState({
                        selectedPosts: temp
                    });

                    for (let m = 0; m < temp.length; m++) {
                        let coords = [];
                        for (let p = 0; p < temp[m].polyline.length; p++) {
                            coords.push(fromLonLat([temp[m].polyline[p].lng, temp[m].polyline[p].lat]));
                        }
                        let feature = new Feature({
                            geometry: new LineString(coords),
                            name: 'Line',
                        });
                        feature.setStyle(style);
                        featureArr.push(feature);
                    }

                    let layerLines = new VectorLayer({
                        name: "marshalls",
                        className: "dash_map_sectors",
                        source: new VectorSource({
                            features: featureArr
                        }),
                    });

                    this.map.addLayer(layerLines);
                });
            } else {
                let featureArr = [];

                let feature = new Feature({
                    geometry: new LineString(this.makeFullPolyline()),
                    name: 'Line',
                });

                feature.setStyle(style);
                featureArr.push(feature);

                let layerLines = new VectorLayer({
                    name: "marshalls",
                    className: "dash_map_sectors",
                    source: new VectorSource({
                        features: featureArr
                    }),
                });
                this.map.addLayer(layerLines);
            }
        }
    }

    /* RENDER */
    drawFlags() {
        let collectiveFlags = [];
        let fullCourseFlags = [];

        fullCourseFlags.push(
            <div key={"collective"} className={"col-xs-12"}>
                <h3 className={"text-left App_small_title"}>{this.props.t("stateFullCourse")}</h3>
                <hr style={{margin: 2, borderColor: "#FFFFFF"}}/>
                {this.props.fullCourseFlags.map((flag) => {
                    return (
                        <div key={"fullcourse_" + flag.id} className={"col-xs-3"}>
                            <img
                                id={flag.id + "_1_1_" + flag.first_color + "_" + flag.second_color}
                                className={"organizerPanel_flagStyle"}
                                style={this.state.selectedFlagID === flag.id ? ({
                                    boxShadow: "0px 1px 6px 5px rgba(235, 31, 36, 1)"
                                }) : ({})}
                                src={(serverIP + ":" + backendPort + "/images/flags/" + flag.src)}
                                alt={"flag"}
                                onClick={this.handleClickFlag}
                                data-tip={true}
                                data-for={flag["desc_" + this.props.cookies.get("lang")]}
                            />
                            <ReactTooltip id={flag["desc_" + this.props.cookies.get("lang")]} type={"light"}>
                                <span className={"organizerPanel_tooltipStyle"}>{flag["desc_" + this.props.cookies.get("lang")]}</span>
                            </ReactTooltip>
                        </div>
                    );
                })}
            </div>
        );

        collectiveFlags.push(
            <div key={"collective"} className={"col-xs-12"}>
                <h3 className={"text-left App_small_title"}>{this.props.t("statePartial")}</h3>
                <hr style={{margin: 2, borderColor: "#FFFFFF"}}/>
                {this.props.collectiveFlags.map((flag) => {
                    return (
                        <div key={"collective_" + flag.id} className={"col-xs-3"}>
                            <img
                                id={flag.id + "_1_0_" + flag.first_color + "_" + flag.second_color}
                                className={"organizerPanel_flagStyle"}
                                style={this.state.selectedFlagID === flag.id ? ({
                                    boxShadow: "0px 1px 6px 5px rgba(235, 31, 36, 1)"
                                }) : ({})}
                                src={(serverIP + ":" + backendPort + "/images/flags/" + flag.src)}
                                alt={"flag"}
                                onClick={this.handleClickFlag}
                                data-tip={true}
                                data-for={flag["desc_" + this.props.cookies.get("lang")]}
                            />
                            <ReactTooltip id={flag["desc_" + this.props.cookies.get("lang")]} type={"light"}>
                                <span className={"organizerPanel_tooltipStyle"}>{flag["desc_" + this.props.cookies.get("lang")]}</span>
                            </ReactTooltip>
                        </div>
                    );
                })}
            </div>
        );

        this.setState({
            flagRows: (
                <div className={"row row-flex"} style={{marginBottom: 20}}>
                    {fullCourseFlags}
                    {collectiveFlags}
                </div>
            ),
        });
    }

    render() {
        let disableSendButton;
        if (this.state.isCollective && !this.state.isFullCourse) {
            disableSendButton = this.state.selectedPosts.length === 0;
        } else {
            disableSendButton = false;
        }

        return (
            <div className={$(window).width() > 1200 ? "vcenter-no-flex" : ""}>
                <div className={"col-xs-12 organizerPanel_customContainer App_carbon_background"}>
                    {this.state.flagRows}
                </div>
                <div className={"col-xs-12 App_carbon_background"} style={{margin: "25px 0 25px 0", borderRadius: 10}}>
                    <div className={"col-xs-6 App_teamTitle"} style={{padding: "10px 0 10px 10px", textAlign: "right"}}>
                        {this.props.t("poweredBy")}
                    </div>
                    <div className={"col-xs-6"} style={{padding: 10}}>
                        <img alt={""} src={logo} height={35} style={{maxHeight: 35, verticalAlign: "text-top"}}/>
                    </div>
                </div>
                <div className={"col-xs-12 organizerPanel_customContainer"} style={{padding: 0}}>
                    <MinimalMap
                        toggleFlagPanel={this.props.toggleFlagPanel}
                        sessionDetails={this.props.sessionDetails}
                        sessionStatus={this.props.sessionStatus}
                        marshallPosts={this.props.marshallPosts}
                    />
                </div>
                <Modal open={this.state.flagModalOpen}
                       onClose={this.handleCloseFlagModal}
                       center={false}
                       classNames={(!this.state.isSingular && !this.state.isFullCourse) ? {modal: "large-modal"} : {modal: "medium-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            <span className={"toolTipStyle"}>{this.state.modalTitle}</span>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        <div className={"row"} style={{marginTop: 10}}>
                            <div className={"col-xs-12"}/>
                            {this.state.isFullCourse && !this.state.isSingular ? (
                                <div className={"col-xs-5 w3-animate-zoom"}>
                                    <label className={"App_black_text"}>{this.props.t("countdown")}</label>
                                    <input
                                        id={"countdownFlag"}
                                        className={"form-control App_black_text"}
                                        type={"number"}
                                        placeholder={this.props.t("valueInSeconds")}
                                        onChange={this.handleCountdownChange}
                                    />
                                    <label className={"App_black_text"}>({this.props.t("zeroMeansInstant")})</label>
                                </div>
                            ) : (
                                <div className={"col-sm-4"}/>
                            )}
                        </div>
                        <div className={"row"} style={{marginTop: 15, padding: 20}}>
                            <div id={"flag_modal_map"} style={(!this.state.isSingular && !this.state.isFullCourse) ? {height: "65vh"} : {}}/>
                        </div>
                    </div>
                    <div className={"modal-footer"}>
                        <div className={"col-sm-12 text-right"}>
                            <button
                                className={"btn App_white_text"}
                                style={{background: "#ff0003", color: "#FFFFFF", marginBottom: 20, fontWeight: "bold"}}
                                onClick={this.handleSendFlag}
                                disabled={disableSendButton}
                            >{this.props.t("sendFlag")}
                            </button>
                            <button
                                className={"btn App_white_text"}
                                style={{background: "#ff0003", color: "#FFFFFF", marginBottom: 20, fontWeight: "bold"}}
                                onClick={this.handleCloseFlagModal}
                            >{this.props.t("close")}
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

class CarDisplayLogModal extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            myTable: "#logging",
            myTableBody: "#logging tbody",
            myTableRows: "#logging tbody tr",
            myTableColumn: "#logging th",
            pageSize: 0,
            firstRecord: 0,
            rows: [],
            showTable: false,
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.getCarDisplayLog = this.getCarDisplayLog.bind(this);
        this.paginate = this.paginate.bind(this);
        this.initTable = this.initTable.bind(this);
        this.handleClickPager = this.handleClickPager.bind(this);
        this.makeRows = this.makeRows.bind(this);
        this.getSessionDisplayLog = this.getSessionDisplayLog.bind(this);
        this.popoutTelemetry = this.popoutTelemetry.bind(this);
        this.popoutCode60Monitor = this.popoutCode60Monitor.bind(this);
    }

    /* PAGINATE TABLE */
    initTable() {
        $("#previous").hide();
        $("#next").show();
        this.setState({
            pageSize: 10,
            firstRecord: 0
        });
        // Start the pagination
        this.setState({
            showTable: true,
        }, () => {
            this.paginate(this.state.firstRecord, this.state.pageSize);
        });
    }

    paginate(start, size) {
        let tableRows = $(this.state.myTableRows);
        let end = start + size;
        // Hide all the rows
        tableRows.hide();
        // Show a reduced set of rows using a range of indices.
        tableRows.slice(start, end).show();
        // Show the pager
        $(".paginate").show();
        // If the first row is visible hide prev
        if (tableRows.eq(0).is(":visible")) {
            $('#previous').prop("disabled", true);
        } else {
            $('#previous').prop("disabled", false);
        }
        // If the last row is visible hide next
        if (tableRows.eq(tableRows.length - 1).is(":visible")) {
            $('#next').prop("disabled", true);
        } else {
            $('#next').prop("disabled", false);
        }
    }

    handleClickPager(e) {
        e.preventDefault();
        let tableRows = $(this.state.myTableRows);
        let tmpRec = this.state.firstRecord;
        let pageSize = this.state.pageSize;

        // Define the new first record
        if (e.target.id === "next") {
            tmpRec += pageSize;
        } else {
            tmpRec -= pageSize;
        }

        // The first record is < of 0 or > of total rows
        if (tmpRec < 0 || tmpRec > tableRows.length) {
            return;
        }

        // Update the current record
        this.setState({
            firstRecord: tmpRec,
        }, () => {
            this.paginate(tmpRec, pageSize);
        });
    }

    /* HANDLERS */
    handleShow() {
        this.setState({
            show: true,
        }, () => {
            if (this.props.car) {
                this.getCarDisplayLog();
            } else {
                this.getSessionDisplayLog();
            }
        });
    }

    handleClose() {
        this.setState({
            show: false,
            rows: [],
        });
    }

    /* GET DATA */
    getCarDisplayLog() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getCarFlagsIssued',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                carID: helper.props.car.id,
                sessionID: parseInt(helper.props.sessionID),
            },
            success: function (data) {
                helper.makeRows(data);
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                return false;
            }
        });
    }

    getSessionDisplayLog() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionFlagsIssued',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: parseInt(helper.props.sessionID),
            },
            success: function (data) {
                helper.makeRows(data);
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                return false;
            }
        });
    }

    /* POPOUT METHODS */
    popoutTelemetry(e) {
        e.preventDefault();
        let parts = e.currentTarget.value.split("_");
        window.open(
            "/flagIssueDetails/" +
            this.props.eventID + "/" +
            this.props.sessionID + "/" +
            parts[0] + "/" +
            parts[1] + "/" +
            parts[2] + "/" +
            this.props.userID + "/" +
            this.props.sessionDetails.map_center_lat + "/" +
            this.props.sessionDetails.map_center_lng + "/" +
            this.props.sessionDetails.map_center_zoom_level + "/" +
            this.props.sessionDetails.map_rotation + "/" +
            parts[3] + "/" +
            null,
            'flagIssueDetails',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no, width=0,height=0,left=20,top=100,width=800,height=850",
        );
    }

    popoutCode60Monitor(e) {
        e.preventDefault();
        window.open(
            "/code60monitor/" + this.props.eventID + "/" + this.props.sessionID + "/" + this.props.userID + "/" + e.currentTarget.value,
            'code60monitor',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000,width=1800,height=1000",
        );
    }

    /* RENDER */
    makeRows(issueList) {
        let rows;
        if (issueList && issueList.length > 0) {
            rows = (
                issueList.map((flag_issue, i) => {
                    let code60 = true;
                    for (let c = 0; c < flag_issue.sts_flag_type_by_sectors.length; c++) {
                        if (flag_issue.sts_flag_type_by_sectors[c].id !== 13) {
                            code60 = false;
                            break;
                        }
                    }

                    return (
                        <tr key={"issue_flag_" + i} className={"App_black_text"}>
                            <td className={"text-center"}>
                                {this.props.customTitle ? (
                                    (code60 ? (
                                        <button
                                            value={flag_issue.id}
                                            style={{background: "#ff0003", fontWeight: "bold"}}
                                            type={"button"}
                                            className={"btn printWhite"}
                                            onClick={this.props.car ? this.popoutTelemetry : this.popoutCode60Monitor}
                                            disabled={!flag_issue.flag_clear_date}
                                        >
                                            <i className="fas fa-search" style={{color: "#FFFFFF"}}/>
                                        </button>
                                    ) : null)
                                ) : (
                                    <button
                                        value={this.props.car.id + "_" + flag_issue.flag_issue_date + "_" + flag_issue.flag_clear_date + "_" + flag_issue.id}
                                        style={{background: "#ff0003", fontWeight: "bold"}}
                                        type={"button"}
                                        className={"btn printWhite"}
                                        onClick={this.popoutTelemetry}
                                        disabled={!flag_issue.flag_clear_date}
                                    >
                                        <i className="fas fa-search" style={{color: "#FFFFFF"}}/>
                                    </button>
                                )}
                            </td>
                            <td>
                                <div className={"vcenter"} style={{height: "8.5vh", padding: 0}}>
                                    <MarshallWarningComponent
                                        marshallPosts={this.props.marshallPosts}
                                        sendFlag={null}
                                        fullCourseFlags={null}
                                        sessionStatus={flag_issue.sts_flag_type_by_sectors}
                                        isSingleVehicle={true}
                                        enableClick={false}
                                        isFlagPanel={false}
                                        hasTooltip={false}
                                    />
                                </div>
                            </td>
                            <td className={"text-center"}>
                                {formatDate(parseInt(flag_issue.flag_issue_date), this.props.sessionDetails.timezone)}
                            </td>
                            {this.props.car ? (
                                <td className={"text-center"}>
                                    {flag_issue.display_date ? formatDate(parseInt(flag_issue.display_date), this.props.sessionDetails.timezone) : "---"}
                                    <span style={{float: "right"}}><b>{(
                                        isNaN(Math.abs(parseInt(flag_issue.display_date) - parseInt(flag_issue.flag_issue_date)) / 1000) ? (
                                            "---"
                                        ) : (
                                            "(" + Math.abs(parseInt(flag_issue.display_date) - parseInt(flag_issue.flag_issue_date)) / 1000 + " s)"
                                        ))}</b>
                                    </span>
                                </td>
                            ) : null}
                            <td className={"text-center"}>
                                {formatDate(parseInt(flag_issue.flag_clear_date), this.props.sessionDetails.timezone)}
                            </td>
                        </tr>
                    );
                })
            );
        } else {
            rows = null;
        }

        this.setState({
            rows: rows,
        }, () => {
            this.initTable();
        });
    }

    render() {
        return (
            <>
                {this.props.customTitle ? (
                    <button className={"openbtn button text-center w3-animate-zoom"} style={{width: "100%"}} onClick={this.handleShow}>
                        {this.props.customTitle}
                    </button>
                ) : (
                    <button className={"openbtn button text-center w3-animate-zoom"} style={{whiteSpace: "nowrap", width: "100%"}} onClick={this.handleShow}>
                        #{this.props.car.livery_number + " " + this.props.car.short_name}
                    </button>
                )}
                <Modal open={this.state.show}
                       onClose={this.handleClose}
                       center={false}
                       classNames={{modal: "large-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            {this.props.customTitle ? (<div/>) : (<span className={"App_black_text"} style={{fontSize: 25}}><b>#{this.props.car.livery_number + " " + this.props.car.short_name}</b></span>)}
                            <span className={"App_black_text"} style={{fontSize: 25, float: "right"}}>{this.props.t("displayLog")}</span>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        <div className={"table-scroll-parent"} style={{height: "70vh"}}>
                            {this.state.showTable && this.state.rows && this.state.rows.length > 0 ? (
                                <table id={"logging"} className={"table table-hover table-condensed table-scroll-child"}>
                                    <thead>
                                    <tr>
                                        <th className={"App_header text-center"} style={{color: "#000000", width: "3%"}}/>
                                        <th className={"App_header text-center"} style={{color: "#000000", width: "38%"}}>{this.props.t("sessionState").toUpperCase()}</th>
                                        <th className={"App_header text-center"} style={{color: "#000000", width: "18%"}}>{this.props.t("issued").toUpperCase()}</th>
                                        {this.props.car ? (<th className={"App_header text-center"} style={{color: "#000000", width: "23%"}}>{this.props.t("display").toUpperCase()}</th>) : null}
                                        <th className={"App_header text-center"} style={{color: "#000000", width: "18%"}}>{this.props.t("clear").toUpperCase()}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.rows}
                                    </tbody>
                                </table>
                            ) : (
                                <>
                                    {this.state.rows !== null ? (
                                        <div style={{width: "100%"}}>
                                            <div className={"loader"} style={{margin: "0 auto", marginTop: "15%"}}/>
                                        </div>
                                    ) : (
                                        <div className={"App_title"}>{this.props.t("noResults")}</div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                    <div className={"modal-footer"}>
                        <div style={{float: "left"}}>
                            <button className={"paginate btn App_white_text"}
                                    style={{background: "#ff0003", fontWeight: "bold", marginRight: 3}}
                                    onClick={this.handleClickPager}
                                    id={"previous"}
                            >{this.props.t("previous")}</button>
                            <button className={"paginate btn App_white_text"}
                                    style={{background: "#ff0003", fontWeight: "bold"}}
                                    onClick={this.handleClickPager}
                                    id={"next"}
                            >{this.props.t("next")}</button>
                        </div>
                        <button
                            onClick={this.handleClose}
                            className={"btn App_white_text"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("close")}
                        </button>
                    </div>
                </Modal>
            </>
        );
    }
}

class MinimalMap extends PureComponent {

    constructor(props) {
        super(props);

        this.setupMap = this.setupMap.bind(this);
        this.statusUpdatePolyline = this.statusUpdatePolyline.bind(this);
    }

    /* LIFECYCLE METHODS */
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.sessionDetails !== this.props.sessionDetails) {
            this.setupMap();
        }
        if (prevProps.sessionStatus !== this.props.sessionStatus) {
            this.statusUpdatePolyline(this.props.sessionStatus);
        }
        if (prevProps.toggleFlagPanel !== this.props.toggleFlagPanel) {
            setTimeout(() => {
                if (this.flag_map) {
                    this.flag_map.updateSize();
                }
            }, 500);
        }
    }

    /* GET DATA */
    setupMap() {
        this.flag_map = new Map({
            target: "flag_map",
            layers: [
                new TileLayer({
                    source: new XYZ({
                        attributions: 'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer">ArcGIS</a>',
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                    })
                }),
            ],
            view: new View({
                center: fromLonLat([this.props.sessionDetails.map_center_lng, this.props.sessionDetails.map_center_lat]),
                zoomFactor: 1.1,
                zoom: this.props.sessionDetails.map_center_zoom_level - 6,
                maxZoom: 141,
                rotation: this.props.sessionDetails.map_rotation,
            }),
            loadTilesWhileAnimating: true,
            loadTilesWhileInteracting: true,
        });

        setTimeout(() => {
            this.flag_map.updateSize();
        }, 1500);
    }

    statusUpdatePolyline(sessionStatus) {
        this.flag_map.getLayers().forEach((layer) => {
            if (layer && layer.get('name') && layer.get('name') === "sectors") {
                this.flag_map.removeLayer(layer);
            }
        });
        let featureArr = [];
        for (let i = 0; i < this.props.marshallPosts.length; i++) {
            if (sessionStatus[i] !== null) {
                let coords = [];
                for (let c = 0; c < this.props.marshallPosts[i].polyline.length; c++) {
                    coords.push(fromLonLat([this.props.marshallPosts[i].polyline[c].lng, this.props.marshallPosts[i].polyline[c].lat]));
                }

                let style = null;
                if (sessionStatus[i].second_color) {
                    let color1 = sessionStatus[i].first_color;
                    let color2 = sessionStatus[i].second_color;
                    let numberOfStripes = 50;
                    for (let x = 0; x < numberOfStripes * 2; x++) {
                        let thickness = 300 / numberOfStripes;
                        patternContext.beginPath();
                        patternContext.strokeStyle = x % 2 ? color1 : color2;
                        patternContext.lineWidth = thickness;
                        patternContext.lineCap = 'round';

                        patternContext.moveTo(x * thickness + thickness / 2 - 300, 0);
                        patternContext.lineTo(x * thickness + thickness / 2, 300);
                        patternContext.stroke();
                    }

                    // Create our primary canvas and fill it with the pattern
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    const pattern = ctx.createPattern(patternCanvas, 'repeat');
                    ctx.fillStyle = pattern;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);

                    style = new Style({
                        stroke: new Stroke({
                            lineCap: "round",
                            lineJoin: "round",
                            width: 9,
                            color: pattern,
                        }),
                    });
                } else {
                    style = new Style({
                        stroke: new Stroke({
                            lineCap: "round",
                            lineJoin: "round",
                            width: 9,
                            color: sessionStatus[i].first_color,
                        }),
                    });
                }
                let feature = new Feature({
                    geometry: new LineString(coords),
                    name: 'Line',
                });
                feature.setStyle(style);
                featureArr.push(feature);
            }
        }
        let layerLines = new VectorLayer({
            name: "sectors",
            className: "dash_map_sectors",
            source: new VectorSource({
                features: featureArr
            }),
        });
        this.flag_map.addLayer(layerLines);
    }

    render() {
        return (
            <div className={"col-xs-12"} id={"flag_map"} style={{padding: 0}}/>
        );
    }
}

export default withTranslation("translations")(withCookies(FlagMonitor));
